<div class="stiky">
    <clever-header2></clever-header2>
</div>